import { SectionCard } from "@/components/common/SectionCard";
import { ServiceQuotesOfferingForm } from "@/components/proposal-formats/ServiceQuotesOfferingForm";
import type { useServiceOfferingsCatalog } from "./useServiceOfferingsCatalog";

export function ServiceSetupBasicsSection(props: {
  catalog: ReturnType<typeof useServiceOfferingsCatalog>;
  onSaved?: () => void;
}) {
  const { catalog, onSaved } = props;

  return (
    <SectionCard title="Basics">
      <p className="mb-3 text-xs text-gray-500 dark:text-zinc-400">
        Core identity and default scheduling seeds for this service.
      </p>
      <ServiceQuotesOfferingForm
        draft={catalog.draft}
        setDraft={catalog.setDraft}
        queues={catalog.queues}
        queuesUnavailable={catalog.queuesUnavailable}
        actionBusy={catalog.actionBusy}
        slugReadOnly
        hideQuotable
        compact
        onSave={async () => {
          const saved = await catalog.saveOffering();
          if (saved) onSaved?.();
        }}
      />
    </SectionCard>
  );
}
